var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentType != 'profile')?_c('router-link',{attrs:{"to":{ name: _vm.documentType + '-version', params: { id: _vm.id, version: _vm.version, lang: _vm.lang } },"rel":"nofollow"}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }